<div class="container-fluid">
  <mat-divider class="mb-4"></mat-divider>
  <form [formGroup]="direccionForm" class="row">
    <div class="form-group col-md-6">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Buscar</mat-label>
        <input matInput id="calleInputCom" name="calleInputCom" #calleInputCom [disabled]="formFirmado">
        <mat-icon matSuffix color="primary">search</mat-icon>
      </mat-form-field>
    </div>
    <mat-divider class="mb-4"></mat-divider>
    <div class="form-group col-md-6">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Calle</mat-label>
        <input matInput formControlName="calle" readonly>
      </mat-form-field>
    </div>

    <div class="form-group col-md-3">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Número</mat-label>
        <input matInput id="numero" name="numero" formControlName="numero" >
      </mat-form-field>
    </div>

    <div class="form-group col-md-3">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Depto</mat-label>
        <input matInput formControlName="depto">
      </mat-form-field>
    </div>

    <div class="form-group col-md-3">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Comuna</mat-label>
        <input matInput formControlName="comuna" readonly>
      </mat-form-field>
    </div>

    <div class="form-group col-md-3">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Región</mat-label>
        <input matInput formControlName="region" readonly>
      </mat-form-field>
    </div>

    <div class="form-group col-md-3">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>País</mat-label>
        <input matInput formControlName="pais" readonly>
      </mat-form-field>
    </div>
    <div class="row">
      <div class="mt-4">
        <button id="doreccionComSiguienteBtn" type="button" class="ml1 mr1 fr" mat-raised-button color="primary" (click)="enviarFormulario()">Siguiente</button>
        <button id="doreccionComVolver" type="button" mat-raised-button color="secundary" class="ml1 mr1 fr" (click)="volver()">Volver</button>
      </div>
    </div> 
  </form>
</div>
